<template>
  <van-popup v-model="showPopup" position="bottom" :round="true">
    <div class="content-wrapper">
      <p class="tips">{{ tips }}</p>
      <slot></slot>
      <div class="cancel-btn" @click="_cancelPopup">
        取消
      </div>
    </div>
  </van-popup>
</template>
<script>
import { Popup } from 'vant';

export default {
  name: 'basePopup',
  props: {
    tips: String
  },
  components: {
    [Popup.name]: Popup,
  },
  data() {
    return {
      showPopup: false,
    };
  },
  methods: {
    _showPopup() {
      this.showPopup = true;
    },
    _cancelPopup() {
      this.showPopup = false;
    },
  }

};
</script>
<style lang="less" scoped>
.content-wrapper {
  text-align: center;
  padding: 10px 0 24px;
  color: #333333;

  .tips {
    padding: 10px;
    line-height: 30px;
    font-size: 12px;
    color: #999999;
  }

  .cancel-btn {
    height: 48px;
    line-height: 48px;
    font-size: 16px;
    border-top: 8px solid #FAFAFC;
    margin-top: 12px;
  }

}

.night {
  .content-wrapper {
    background: #121212;
    color: #D2D2D3;
  }

  .cancel-btn {
    border-top: 8px solid #252528;
  }
}
</style>
